module.exports = __webpack_public_path__ + "img/bachelor-holztechnik-sab-1-inhalt-aufbau.3b215386.jpg";